

import React, { useState } from 'react'
import './styles.scss'

const GoToTop = (props) => {

    let scrollPage = () => {
        let element = document.querySelector('.App');

        element.scrollIntoView({
            behavior: 'smooth'
          });
    }

    return (
        <section className="go-to-top">
            <div className="container">
                <div class="back-to-top-container ">
                    <div class="row justify-content-end">
                        <div class="col-auto">
                            <button class="none-appearance back-to-top" onClick={ () => scrollPage() }></button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        
    )
}

export default GoToTop;